import script from "./ManagementCalendarWidgetWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementCalendarWidgetWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ManagementCalendarWidgetWrapper.vue?vue&type=style&index=0&id=b89b7986&scoped=true&lang=css"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b89b7986"]])

export default __exports__